export const resources = {
  SortButton: '',
  SortOptionDescending: '',
  SortOptionAscending: ''
};
